import { EmptyState } from "@cmde/shadcn";
import { SearchIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function FilteredEmptySeasonsList() {
  const { t } = useTranslation();

  return (
    <EmptyState
      title={t("seasons.list.general.no_matching_seasons_found")}
      description={t("seasons.list.general.try_adjusting_your_search_terms")}
      icon={<SearchIcon />}
    />
  );
}
